import React from 'react';
import { CancelButton } from 'Components/Fields/Buttons';
import { Modal } from 'Components/Modal';
import { PlanLink } from 'Features/Plans/PlanLink';
import { getSimplifiedPlanDisplayName } from 'Utils/Plans';
import './PlanDetailModal.css';

export function PlanDetailModal({
  show,
  onClose,
  planBenefits,
  plan,
  isPlanActive = false,
  customClass = '',
  disableCta = false,
}) {
  const header = `${getSimplifiedPlanDisplayName(plan)} Subscription Benefits`;
  return (
    <Modal customClass={customClass} isShowing={show} onClose={onClose}>
      <div className="planDetailsModal">
        <div className="planDetailsWrapper">
          <div className="planImageWrapper">
            {planBenefits.image && <img className="planImage" src={planBenefits.image} alt={header} />}
          </div>
          <div className="planDetailsHeader">{header}</div>
          <div className="planDetailsBenefitsWrapper">
            <ul className="planDetailBenefits">
              {planBenefits.details.list.map((benefit, index) => (
                <li className="planBenefit" key={index}>
                  {benefit}
                </li>
              ))}
            </ul>
          </div>
          {!isPlanActive && (
            <div className="planDetailsCta">
              {!disableCta && <PlanLink plan={plan} />}
              <CancelButton text="Close" className="hollow" onClick={onClose} />
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
}
